import { ScheduleRequestRef } from '@csp/csp-common-scheduling';
import { WebHcpPatientVisitEntry } from '@csp/csp-web-content-definitions';
import {
  ScheduleVisitsContent,
  ScheduleVisitTexts,
  ScheduleVisitTextsMapper,
  VisitRequest,
} from '@csp/csp-common-visits';
import { SelectProps } from '@csp/csp-web-ui';
import { ScheduleRequestRefKey } from '../../patient-list/patient-list-visit/mapper/ScheduleRequestRefKey';

export type VisitRequestInfo = VisitRequest & {
  texts: ScheduleVisitTexts;
  toSelectItem(): SelectProps<ScheduleRequestRefKey>;
  toScheduleRequestRef(): ScheduleRequestRef;
};

const from = (
  request: VisitRequest,
  content: ScheduleVisitsContent,
  patientVisitTexts: WebHcpPatientVisitEntry,
): VisitRequestInfo => {
  const texts = ScheduleVisitTextsMapper.fromVisitRequest(patientVisitTexts, content, request, undefined);
  return {
    ...request,
    texts,
    toSelectItem: () => ({
      value: ScheduleRequestRefKey.toKey(request),
      children: texts.title ?? request.requestCode,
    }),
    toScheduleRequestRef: () => ScheduleRequestRef.fromGenericRequest(request),
  };
};
export const VisitRequestInfo = {
  from,
};
